import React from "react";
import { HelpTooltip } from "../../../../components";

interface DesignerSectionHeadingProps {
  title: string;
  helpLabel: string;
  helpText: string;
  level?: 2 | 3;
  className?: string;
}

export const DesignerSectionHeading: React.FC<
  DesignerSectionHeadingProps
> = ({ title, helpLabel, helpText, level = 2, className = "" }) => {
  const Heading = level === 2 ? "h2" : "h3";

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <Heading
        className={level === 2 ? "text-xl font-bold" : "text-base font-bold"}
      >
        {title}
      </Heading>
      <HelpTooltip label={helpLabel} content={helpText} />
    </div>
  );
};
